/**
 * Zod schemas for Impact Notes edit form.
 *
 * Parity: Angular form declares `title`, `description`, `daterange` all required.
 * Here we split the range into `from_date` / `to_date` for simpler RHF wiring.
 * Both must be YYYY-MM-DD strings; end >= start is enforced via refine.
 */

import { z } from 'zod'

const dateString = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in YYYY-MM-DD format')

export const impactNoteFormSchema = z
  .object({
    title: z.string().min(1, 'Title is required'),
    description: z.string().min(1, 'Description is required'),
    from_date: dateString,
    to_date: dateString,
  })
  .refine((value) => value.to_date >= value.from_date, {
    message: 'End date must be on or after start date',
    path: ['to_date'],
  })

export type ImpactNoteFormValues = z.infer<typeof impactNoteFormSchema>
